module.exports = __webpack_public_path__ + "img/product-headphones.bcc03dd7.jpg";